import urlTemplate from 'url-template';

function getFocalPoint(img) {
  var _img$focalPoint, _img$focalPoint2, _img$focalPoint3, _img$focalPoint4;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$xFocalPoint = _ref.xFocalPoint,
    defX = _ref$xFocalPoint === void 0 ? 'x_iw_div_2' : _ref$xFocalPoint,
    _ref$yFocalPoint = _ref.yFocalPoint,
    defY = _ref$yFocalPoint === void 0 ? 'y_ih_mul_0.6' : _ref$yFocalPoint;
  // Default focal point should be slightly lower than center
  var xFocalPoint = defX;
  var yFocalPoint = defY;

  // If focal point is specified, use it
  if (((_img$focalPoint = img.focalPoint) === null || _img$focalPoint === void 0 ? void 0 : _img$focalPoint.x) != null && ((_img$focalPoint2 = img.focalPoint) === null || _img$focalPoint2 === void 0 ? void 0 : _img$focalPoint2.y) != null) {
    xFocalPoint = "x_".concat(img.focalPoint.x);
    yFocalPoint = "y_".concat(img.focalPoint.y);
  } else if (((_img$focalPoint3 = img.focalPoint) === null || _img$focalPoint3 === void 0 ? void 0 : _img$focalPoint3.left) != null && !!((_img$focalPoint4 = img.focalPoint) !== null && _img$focalPoint4 !== void 0 && _img$focalPoint4.right) != null) {
    xFocalPoint = "x_".concat(Math.round(img.width * img.focalPoint.left));
    yFocalPoint = "y_".concat(Math.round(img.height * img.focalPoint.top));
  } else if (img.size) {
    // If size is specified, use it to calculate default focal point
    if (img.size.width) {
      xFocalPoint = "x_".concat(Math.floor(img.size.width / 2));
    }
    if (img.size.height) {
      yFocalPoint = "y_".concat(Math.floor(img.size.height * 0.6));
    }
  }
  return {
    xFocalPoint: xFocalPoint,
    yFocalPoint: yFocalPoint
  };
}
function createTransformParameter(width, height, xFocalPoint, yFocalPoint, format, transformValues, ar) {
  var transformationTemplate = urlTemplate.parse('c_fill{width}{height}{focalPoint}{format}{transformValues}{ar}/');
  return transformationTemplate.expand({
    width: width ? ",w_".concat(Math.floor(width)) : '',
    height: height ? ",h_".concat(Math.floor(height)) : '',
    ar: ar ? ",ar_".concat(ar) : '',
    focalPoint: ",g_xy_center,".concat(xFocalPoint, ",").concat(yFocalPoint),
    format: format ? ",f_".concat(format) : '',
    transformValues: transformValues ? ",".concat(transformValues) : ''
  });
}
function resolveTemplate(uriTemplate, paramValues) {
  var template = urlTemplate.parse(uriTemplate);
  return template.expand(paramValues);
}
function convertToUrl(img, width, height) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref2$format = _ref2.format,
    format = _ref2$format === void 0 ? 'f_auto' : _ref2$format,
    _ref2$transformValues = _ref2.transformValues,
    transformValues = _ref2$transformValues === void 0 ? 'q_auto:low' : _ref2$transformValues;
  var ar = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var _getFocalPoint = getFocalPoint(img),
    xFocalPoint = _getFocalPoint.xFocalPoint,
    yFocalPoint = _getFocalPoint.yFocalPoint;
  var paramValues = img.defaultUriTemplateParams || {};
  paramValues.transform = createTransformParameter(width, height, xFocalPoint, yFocalPoint, format, transformValues, ar);
  var url = resolveTemplate(img.cloudinaryUriTemplate, paramValues);
  return url;
}

export { convertToUrl };
//# sourceMappingURL=cloudinary.js.map
